<div class="fixed bottom-4 right-4 shadow-md" [ngClass]="{'rigth-4': !viewModel.isRightView(), 'left-4': viewModel.isRightView()}">
  <div [hidden]="!viewModel.showScanQR()">
    <fv-button [icon]="qrIconClass" (click)="onClickScanQR()" [size]="BUTTON_SIZE.xl"
      [disabled]="viewModel.disableScanQR()" [variant]="BUTTON_VARIANT.icononly" [type]="BUTTON_TYPE.filled"
      [color]="BUTTON_COLOR.secondary"></fv-button>
  </div>
</div>